import {gql} from '@apollo/client'

export const CREATE_GROUP_ASSIGNMENT = gql`
  mutation createGroupAssignment($groupData: GroupAssignmentInput!) {
    createGroupAssignmentMutation(groupData: $groupData) {
      groupAssignment {
        id
        name
        visibleForTickets
        supervisors {
          edges {
            node {
          id
          firstName
          lastName
          email
            }
          }
        }
        organization {
          id
          name
        }
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_GROUP_ASSIGNMENT = gql`
  mutation updateGroupAssignment($groupId: ID!, $groupData: GroupAssignmentInput!) {
    updateGroupAssignmentMutation(groupId: $groupId, groupData: $groupData) {
      groupAssignment {
        id
        name
        visibleForTickets
        supervisors {
          edges {
            node {
          id
          firstName
          lastName
          email
            }
          }
        }
        organization {
          id
          name
        }
      }
      success
      errors {
        field
        message
      }
    }
  }
`
